import * as iid from '../common/bookingElementId'
import { GT_COMPANY_ID, HANS_BRANCH_ID, HANS_COMPANY_ID, STA_COMPANY_ID } from '../../helper/companyIdhardcode'
import { STA_COVER_C_ID, STA_PACKET_C_ID } from './constants'
export const senderSect = ['GSTIN & E-Way Bill', 'ID Proof', 'Sender Other Info', 'Bill Info', 'Home Pickup']
export const receiverSect = ['Receiver GSTIN', 'Receiver Other Info', 'Home Delivery']
export const senderSectTabs = [
  { id: 0, name: 'GSTIN & E-Way Bill' },
  { id: 1, name: 'ID Proof' },
  { id: 2, name: 'Sender Other Info' },
  { id: 3, name: 'Bill Info' },
  { id: 4, name: 'Home Pickup' },
]
export const receiverSectTabs = [
  { id: 0, name: 'Receiver GSTIN' },
  { id: 1, name: 'Receiver Other Info' },
  { id: 2, name: 'Home Delivery' },
]
export const deliveryreceiverSect =[receiverSectTabs[0],{id:3,name:'ID Proof'},...receiverSectTabs.slice(1)]
export const fileTypes = [
  'image/apng',
  'image/bmp',
  'image/gif',
  'image/jpeg',
  'image/pjpeg',
  'image/png',
  'image/svg+xml',
  'image/tiff',
  'image/webp',
  'image/x-icon',
]
export const getPriceSection = (companySettings, roleRights, ParentCompanyID, citywiseBranchList,intCompanyID,ConsignmentSubTypeID,DefaultCurrencyID,intBranchID) => {
  const { IsCartage, IsDelCartage, IsHamali, IsOperatorHamali, IsInsurance, IsDocumentDisable, IsPickUpAndDropOffChg,IsMiscChgRemove,IsHamaliDisable,IsOperatorHamaliDisable,IsInsuranceDisable,PickUpFeeDisable,IsDropoffFeeDisable } =
    companySettings
  const {
    RemovePickupcartage,
    RemoveMisccartage,
    RemoveBookingDropcartage,
    RemoveHamali,
    RemoveOpHamali,
    RemoveValuation,
    RemoveDocfee,
    RemovePickupfee,
    RemoveDropofffee,
    IsServiceTax,
  } = companySettings
  const isHansCase = [HANS_COMPANY_ID].includes(intCompanyID) && [HANS_BRANCH_ID].includes(intBranchID);
  const [branchConfiguration = {}] = citywiseBranchList
  const { DisablePickupCartage, DisableMiscellaneousCartage, DisableBookingDeliveryCartage } = branchConfiguration
  const { AllowHamaliEdit, AllowOperatorHamaliEdit } = roleRights
  const staCoverPacket = intCompanyID === STA_COMPANY_ID && [STA_COVER_C_ID, STA_PACKET_C_ID].includes(ConsignmentSubTypeID)
  let priceSect = [
    {
      label: 'Total Freight',
      type: 'text',
      id: iid.TotalFreight,
      width: '9.3%',
      readOnly: true,
      sF: true,
    },
    {
      label: intCompanyID === GT_COMPANY_ID || ParentCompanyID === GT_COMPANY_ID ? 'Additional Cartage' :intCompanyID === HANS_COMPANY_ID ? 'Crossing' : 'Pickup Cartage',
      type: 'text',
      id: 'CCBrkup_pckp',
      width: '9.3%',
      readOnly: !IsCartage || DisablePickupCartage === 1 || staCoverPacket,
      sF: !RemovePickupcartage,
    },
    {
      label: 'Misc. Cartage',
      type: 'text',
      id: 'CCBrkup_cmsn',
      width: '9.3%',
      readOnly: IsMiscChgRemove || DisableMiscellaneousCartage === 1 || staCoverPacket,
      sF: !RemoveMisccartage,
    },
    {
      label: 'Drop Cartage',
      type: 'text',
      id: iid.delCartage,
      width: '9.3%',
      readOnly: !IsDelCartage || DisableBookingDeliveryCartage === 1,
      sF: !RemoveBookingDropcartage,
    },
    {
      label: 'Hamali',
      type: 'text',
      id: iid.hamali,
      width: '9.3%',
      readOnly: IsHamaliDisable || !AllowHamaliEdit,
      sF: !RemoveHamali,
    },
    {
      label: intCompanyID === STA_COMPANY_ID ? 'ToPay Charge' : 'Op Hamali',
      type: 'text',
      id: iid.opHamali,
      width: '9.3%',
      readOnly: IsOperatorHamaliDisable || !AllowOperatorHamaliEdit,
      sF: isHansCase ? 1 : ![HANS_COMPANY_ID].includes(intCompanyID) ? !RemoveOpHamali : 0,
    },
    {
      label: DefaultCurrencyID === 2 ? 'Insurance' : 'Valuation',
      type: 'text',
      id: iid.valuation,
      width: '9.3%',
      readOnly: IsInsuranceDisable,
      sF: !RemoveValuation,
    },
    {
      label: 'Doc Fee',
      type: 'text',
      id: iid.docFee,
      width: '9.3%',
      readOnly: IsDocumentDisable || ParentCompanyID === GT_COMPANY_ID, //intCompanyID === 10
      sF: !RemoveDocfee,
    },
    {
      label: 'Pickup Fee',
      type: 'text',
      id: iid.pickupFee,
      width: '9.3%',
      readOnly: PickUpFeeDisable,
      sF: !RemovePickupfee,
    },
    {
      label: 'Dropoff Fee',
      type: 'text',
      id: iid.dropoffFee,
      width: '9.3%',
      readOnly: IsDropoffFeeDisable,
      sF: !RemoveDropofffee,
    },
    {
      label: 'GST',
      type: 'text',
      id: iid.gst,
      width: '9.3%',
      readOnly: true,
      sF: !!IsServiceTax,
    },
  ]
  const activePriceSect = priceSect.filter((a) => a.sF)
  const activeField = activePriceSect.filter((a) => !a.readOnly).map((a) => a.id)
  return [activePriceSect, activeField]
}

export const getConsignmentSection = (intCompanyID, companySettings) => {
  const { IsDescriptionDisable, IsMOPDisable, IsGoodsValueDisable, IsWeightDisable,IsCFTWeightDisable, IsChargedWeightDisable, IsFreight,IsBookingPageRateDisable,IsFreightDisable } = companySettings  //disable.

  const { RemoveDescription, RemovePackMethod, RemoveGoodsvalue, RemoveActualWeight } = companySettings //remove fileds
  const { RemoveCFTWeight, RemoveChargeWeight, RemoveBookingPageRate, IsMultipleConsignment } = companySettings
  return [
    {
      label: 'Consignment Type',
      type: 'text',
      id: iid.consignmentType,
      width: IsMultipleConsignment ? '13%' : '16%',
      sF: true,
      disabled: false,
    },
    {
      label: 'Description',
      type: 'text',
      id: iid.description,
      width: IsMultipleConsignment ? '13%' : '16%',
      sF: !RemoveDescription,
      disabled: IsDescriptionDisable,
    },
    {
      label: 'Pack Method',
      type: 'text',
      id: iid.packMethod,
      width: IsMultipleConsignment ? '9%' : '11.5%',
      sF: !RemovePackMethod,
      disabled: IsMOPDisable,
    },
    { label: 'Unit', type: 'text', id: iid.unit, width: '8%', sF: true, disabled: false },
    {
      label: 'Goods Value',
      type: 'number',
      id: iid.goodsValue,
      width: '8%',
      sF: !RemoveGoodsvalue,
      disabled: IsGoodsValueDisable,
    },
    {
      label: 'Weight(Actual)',
      type: 'text',
      id: iid.weightActual,
      width: '8%',
      sF: !RemoveActualWeight,
      disabled: IsWeightDisable,
    },
    {
      label: intCompanyID === STA_COMPANY_ID ? 'Size (CFT)' : 'Weight (CFT)',
      type: 'text',
      id: iid.weightVolume,
      width: '8%',
      sF: !RemoveCFTWeight,
      disabled: IsCFTWeightDisable,
    },
    {
      label: 'Weight(Charge)',
      type: 'text',
      id: iid.weightCharged,
      width: '8%',
      sF: !RemoveChargeWeight,
      disabled: IsChargedWeightDisable,
    },
    { label: 'Rate', type: 'text', id: iid.rate, width: '8%', sF: !RemoveBookingPageRate, disabled: IsBookingPageRateDisable },
    { label: 'Freight', type: 'text', id: iid.freight, width: '8%', sF: true, disabled: IsFreightDisable },
    {
      label: 'Action',
      type: 'text',
      id: iid.addRemove,
      width: '8%',
      sF: IsMultipleConsignment,
      disabled: !IsMultipleConsignment,
    },
  ]
}
export const getConsignmentSectionForModify = (IsMultipleConsignment) => {
  return [
    {
      label: 'Consignment Type',
      type: 'text',
      id: 'consgmnt_type',
      width: IsMultipleConsignment ? '13%' : '16%',
      sF: true,
    },
    {
      label: 'Description',
      type: 'text',
      id: 'description',
      width: IsMultipleConsignment ? '13%' : '16%',
      sF: true,
    },
    {
      label: 'Pack Method',
      type: 'text',
      id: 'pack_method',
      width: IsMultipleConsignment ? '9%' : '11.5%',
      sF: true,
    },
    { label: 'Unit', type: 'text', id: 'unit', width: '8%', sF: true },
    {
      label: 'Goods Value',
      type: 'number',
      id: 'goods_value',
      width: '8%',
      sF: true,
    },
    {
      label: 'Weight(Actual)',
      type: 'text',
      id: 'wt_actual',
      width: '8%',
      sF: true,
    },
    {
      label: 'Weight (CFT)',
      type: 'text',
      id: 'wt_volume',
      width: '8%',
      sF: true,
    },
    {
      label: 'Weight(Charge)',
      type: 'text',
      id: 'wt_charge',
      width: '8%',
      sF: true,
    },
    { label: 'Rate', type: 'text', id: 'rate', width: '8%', sF: true },
    { label: 'Freight', type: 'text', id: 'freight', width: '8%', sF: true },
  ]
}
export const getmodalData = (PrfTypeoptions) => {
  return {
    send: {
      id: 'addSenderIdProof',
      idProofLabel: 'Sender Id Proof',
      IdProofType: PrfTypeoptions[0],
      IdProof: '',
      IdProofFile: '',
      isSaved: false,
    },
    rec: {
      id: 'addReceiverIdProof',
      idProofLabel: 'Receiver Id Proof',
      IdProofType: PrfTypeoptions[0],
      IdProof: '',
      IdProofFile: '',
    },
    sendPic: {
      id: 'addSenderPic',
      label: 'Sender Image',
      PicFile: '',
      isSaved: false,
    },
    recPic: {
      id: 'addReceiverPic',
      label: 'Receiver Image',
      PicFile: '',
      isSaved: false,
    },
  }
}
export const senderTabIds = (index) => {
  return {
    id: `sender-tab-${index}`,
    'aria-controls': `sender-tabpanel-${index}`,
  }
}
export const receiverTabIds = (index) => {
  return {
    id: `receiver-tab-${index}`,
    'aria-controls': `receiver-tabpanel-${index}`,
  }
}

export const NavyaDishaBranchCodes = [
  72104, 72108, 72112, 72122, 72123, 72125, 72127, 72129, 72130, 72200, 72202, 72205, 72208, 72218, 72221, 72224, 72225, 72227, 72230,
  72233, 72284, 72290, 72299, 72306, 72309,
]